// extracted by mini-css-extract-plugin
export var active = "_gx-2";
export var recordingDot = "_gx-1";
export var recordingIndicator = "_gx-0";